import { formatNumberMix } from '@/utils'
export default {
  data() { },
  methods: {
    getCardConfig(data = {}) {
      return [
        {
          title: this.$t('ocean-bi::order-link::card1'),
          number: this.$dataCheck(data.thisAvgReceiveDay),
          rate: this.$dataCheck(data.avgReceiveRatio),
          rise: Number(data.thisAvgReceiveDay || 0) > Number(data.lastAvgReceiveDay || 0),
          pre: this.$dataCheck(formatNumberMix(data.lastAvgReceiveDay, 2), '--'),
          next: this.$dataCheck(formatNumberMix(data.thisAvgReceiveDay, 2), '--')
        },
        {
          title: this.$t('ocean-bi::order-link::card2'),
          number: this.$dataCheck(data.thisUndispatchSubOrderNum),
          rate: this.$dataCheck(data.undispatchRatio),
          rise: Number(data.thisUndispatchSubOrderNum || 0) > Number(data.lastUndispatchSubOrderNum || 0),
          pre: this.$dataCheck(data.lastUndispatchSubOrderNum),
          next: this.$dataCheck(data.thisUndispatchSubOrderNum),
          notCompare: true
        },
        {
          title: this.$t('ocean-bi::order-link::card3'),
          number: this.$dataCheck(data.thisWaitDispacherNum),
          rate: this.$dataCheck(data.waitDispacherRatio),
          rise: Number(data.thisWaitDispacherNum || 0) > Number(data.lastWaitDispacherNum || 0),
          pre: this.$dataCheck(data.lastWaitDispacherNum),
          next: this.$dataCheck(data.thisWaitDispacherNum),
          notCompare: true
        },
        {
          title: this.$t('ocean-bi::order-link::card4'),
          number: this.$dataCheck(data.thisOnShippingNum),
          rate: this.$dataCheck(data.onShippingRatio),
          rise: Number(data.thisOnShippingNum || 0) > Number(data.lastOnShippingNum || 0),
          pre: this.$dataCheck(data.lastOnShippingNum),
          next: this.$dataCheck(data.thisOnShippingNum),
          notCompare: true
        },
        {
          title: this.$t('ocean-bi::order-link::card5'),
          number: this.$dataCheck(data.thisReceiveOkNum),
          rate: this.$dataCheck(data.receiveOkRatio),
          rise: Number(data.thisReceiveOkNum || 0) > Number(data.lastReceiveOkNum || 0),
          pre: this.$dataCheck(data.lastReceiveOkNum),
          next: this.$dataCheck(data.thisReceiveOkNum)
        }
      ]
    },
    setUnDeliveryOrder(data = [], chartType) {
      return {
        type: chartType || 'line',
        title: this.$t('ocean-bi::order-link::未配货子订单'),
        ref: 'lineChart',
        height: '325px',
        chart: {
          legend: {
            data: [this.$t('ocean-bi::order-link::未配货子订单')]
          },
          xAxis: {
            data: data.map(item => item.date)
          },
          yAxis: [
            {
              type: 'value',
              splitLine: {
                lineStyle: {
                  color: '#999999',
                  type: 'dashed'
                }
              },
              min: 0,
              axisLabel: {
                margin: 16,
                color: '#999999'
              }
            }
          ],
          series: [
            {
              name: this.$t('ocean-bi::order-link::未配货子订单'),
              type: chartType || 'line',
              data: data.map(item => Number(item.undispatchSubOrderNum))
            }
          ]
        }
      }
    },
    setWaitDeliveryOrder(data = [], chartType) {
      return {
        type: chartType || 'line',
        title: this.$t('ocean-bi::order-link::待发货配货单'),
        ref: 'lineChart',
        height: '325px',
        chart: {
          legend: {
            data: [this.$t('ocean-bi::order-link::待发货配货单')]
          },
          xAxis: {
            data: data.map(item => item.date)
          },
          yAxis: [
            {
              type: 'value',
              splitLine: {
                lineStyle: {
                  color: '#999999',
                  type: 'dashed'
                }
              },
              min: 0,
              axisLabel: {
                margin: 16,
                color: '#999999'
              }
            }
          ],
          series: [
            {
              name: this.$t('ocean-bi::order-link::待发货配货单'),
              type: chartType || 'line',
              data: data.map(item => Number(item.waitDispacherNum))
            }
          ]
        }
      }
    },
    setDeliveryOrder(data = [], chartType) {
      return {
        type: chartType || 'line',
        title: this.$t('ocean-bi::order-link::在途配货单'),
        ref: 'lineChart',
        height: '325px',
        chart: {
          legend: {
            data: [this.$t('ocean-bi::order-link::订单数'), this.$t('ocean-bi::order-link::在途配货单数')]
          },
          xAxis: {
            data: data.map(item => item.date)
          },
          yAxis: [
            {
              type: 'value',
              splitLine: {
                lineStyle: {
                  color: '#999999',
                  type: 'dashed'
                }
              },
              min: 0,
              axisLabel: {
                margin: 16,
                color: '#999999'
              }
            }
          ],
          series: [
            {
              name: this.$t('ocean-bi::order-link::订单数'),
              type: chartType || 'line',
              data: data.map(item => Number(item.odrerNum))
            },
            {
              name: this.$t('ocean-bi::order-link::在途配货单数'),
              type: chartType || 'line',
              data: data.map(item => Number(item.onShippingNum))
            }
          ]
        }
      }
    },
    setHadDeliveryOrder(data = [], chartType) {
      return {
        type: chartType || 'line',
        title: this.$t('ocean-bi::order-link::妥投配货单'),
        ref: 'lineChart',
        height: '325px',
        chart: {
          legend: {
            data: [this.$t('ocean-bi::order-link::在途配货单数'), this.$t('ocean-bi::order-link::妥投配货单数')]
          },
          xAxis: {
            data: data.map(item => item.date)
          },
          yAxis: [
            {
              type: 'value',
              splitLine: {
                lineStyle: {
                  color: '#999999',
                  type: 'dashed'
                }
              },
              min: 0,
              axisLabel: {
                margin: 16,
                color: '#999999'
              }
            }
          ],
          series: [
            {
              name: this.$t('ocean-bi::order-link::在途配货单数'),
              type: chartType || 'line',
              data: data.map(item => Number(item.onShippingNum))
            },
            {
              name: this.$t('ocean-bi::order-link::妥投配货单数'),
              type: chartType || 'line',
              data: data.map(item => Number(item.receiveOkNum))
            }
          ]
        }
      }
    },
  }
}
